import crc32 from 'crc/lib/crc32';
import { digest } from "../../otg/HashStrings";

/**
 * Computes a content-based hash from a given attribute definition
 *
 * Example result: 'p30db51f9' or 'p_0b4a1163c8b8c5c1' (32 and 64 bit hashes, respectively)
 *
 * @private
 *
 * @param {string} name
 * @param {string} category
 * @param {number} dataType
 * @param {string} [dataTypeContext]
 * @param {boolean} useHash64
 * @returns {Promise<string | string>}
 */
export async function getPropertyHash(name, category, dataType, dataTypeContext, useHash64 = false) {
  const identifier = [
  name ?? '',
  category ?? '',
  dataType,
  dataTypeContext ?? ''];


  if (useHash64) {
    const hashString = await digest("SHA-256", identifier.join('|'), true);
    return "p_" + hashString.slice(0, 16);
  }

  return getPropertyHash32(...arguments);
}


/**
 * Computes a 32-bit content-based hash from a given attribute definition
 *
 * Note - this algorithm will uppercase all input parameters before generating, so collisions are much more likely
 *
 * Example result: 'p30db51f9'
 *
 * @private
 *
 * @param {string} name
 * @param {string} category
 * @param {number} dataType
 * @param {string} [dataTypeContext]
 * @param {boolean} useHash64
 * @returns {string}
 */
export function getPropertyHash32(name, category, dataType, dataTypeContext) {
  const identifier = [
  name ?? '',
  category ?? '',
  dataType,
  dataTypeContext ?? ''];

  return `p${crc32(identifier.join('').toUpperCase()).toString(16).padStart(8, '0')}`;
}